import { TransactionType, Transacoes } from '../../extract/extract.model';
import { ETipoOperacao } from './qr-code-return.model';

export class PixTransaction {
	nome: string;
	tipo: string;
	data: Date;
	valor: number;
	isNegative: boolean;
	complemento: string;
	tipoTransacao: TransactionType;
	advanced: Transacoes;
	pixOpenFinance: boolean;
	operationType: ETipoOperacao;
	isInfration: boolean;

	constructor(t: Transacoes) {
		this.nome = t.transacaoPix.nome;
		this.tipo = t.descricaoHistorico;
		this.data = t.dataTransacao;
		this.valor = t.valor;
		this.isNegative = t.tipoMovimentacao === 'D';
		this.tipoTransacao = t.tipoTransacao;
		this.complemento = t.transacaoPix.complemento;
		this.advanced = t;
		this.pixOpenFinance = (Boolean)(t.transacaoPix.iniciadorCNPJ);
		this.operationType = t.transacaoPix.tipoOperacao;
		this.isInfration = (Boolean)(t.transacaoPix.medResultadoAnalise && t.transacaoPix.medValorSolicitado);
	}
}

export enum OperationType{
	PAGAMENTO = 1,
	SAQUE = 2,
	TROCO = 3
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/models/transaction.model.ts